// React
import React, { Component } from "react";
import PropTypes from "prop-types";
// i18n
import { withNamespaces } from "react-i18next";

class Select extends Component {
  getInputState() {
    const {
      errorMessage,
      input: { value },
      meta: { touched },
      t
    } = this.props;
    const invalidInput = {
      hasError: true,
      style: {
        borderColor: "#A90329"
      }
    };
    const validInput = {
      hasError: false,
      style: {
        borderColor: "#7DC27D"
      }
    };
    const neutralInput = { hasError: false, style: {} };
    return touched
      ? value
        ? { ...validInput }
        : {
            ...invalidInput,
            errorMessage:
              errorMessage ||
              t("modules.localization.register.authenticated.error.invalidFields.default")
          }
      : neutralInput;
  }

  render() {
    const { defaultValueLabel, input, label, options, defaultValueKey } = this.props;
    const inputState = this.getInputState();

    return (
      <section>
        {label && <label className="label">{label}</label>}
        <label className="select">
          <select autoComplete="false" style={{ ...inputState.style }} {...input}>
            {defaultValueLabel && !defaultValueKey && (
              <option
                value=""
                defaultValue={!defaultValueKey}
                disabled={this.props.meta.touched && !input.value}
              >
                {defaultValueLabel}
              </option>
            )}
            {options.map((option) => (
              <option
                key={option.key}
                value={option.key}
                defaultValue={option.key === defaultValueKey}
              >
                {option.value}
              </option>
            ))}
          </select>
          <i />
          <em className="invalid" style={{ height: 30, minHeight: 30 }}>
            {inputState.hasError && inputState.errorMessage}
            &nbsp;
          </em>
        </label>
      </section>
    );
  }
}

Select.propTypes = {
  defaultValueLabel: PropTypes.string,
  defaultValueKey: PropTypes.number,
  errorMessage: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }).isRequired
  ),
  t: PropTypes.func.isRequired
};

export default withNamespaces()(Select);
